import axios from "axios";

// The modal owns feedback; polling/network failures must not create toast storms.
export async function fetchHealthStatus(url, signal) {
    const response = await axios.get(url, { signal, baseURL: '' });
    return response.data;
}

export async function resendHealthStatusMask(url, csrfToken, signal) {
    const response = await axios.post(url, {}, {
        signal,
        baseURL: '', // Twig routes already include the CM prefix.
        headers: { 'X-CM-CSRF-TOKEN': csrfToken },
        validateStatus: status => status === 202 || status === 429 || status === 409,
    });
    return response.data;
}
